import React, { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { KnowledgeEditor } from 'apps/aiAutomation/components/KnowledgeEditor'
import { KnowledgeEditorSource } from 'apps/aiAutomation/components/KnowledgeEditor/lib/types'
import { useViewPayload } from 'apps/aiAutomation/hooks/layout'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationKnowledgeSelectors } from 'apps/aiAutomation/store/knowledge'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import {
  KnowledgeEntry,
  KnowledgeEntryDraft,
} from 'shared/api/requests/aiBusinessKnowledge/schemas'

export const SidebarKnowledgeEditor = () => {
  const dispatch = useAppDispatch()
  const viewPayload = useViewPayload(SidebarViewType.KNOWLEDGE_EDITOR)
  const isListEmpty = useAppSelector(
    (state) => AiAutomationKnowledgeSelectors.getList(state).length === 0,
  )

  const handleClose = useCallback(() => {
    dispatch(AiAutomationLayoutActions.sidebarClosed())
  }, [dispatch])

  const handleSaved = useCallback(
    (entry: KnowledgeEntry | KnowledgeEntryDraft, isNew: boolean) => {
      if (isListEmpty) {
        dispatch(
          AiAutomationLayoutActions.currentViewReplaced({
            view: SidebarViewType.KNOWLEDGE_ADDED,
          }),
        )
      } else if (isNew) {
        dispatch(
          AiAutomationLayoutActions.currentViewReplaced({
            view: SidebarViewType.KNOWLEDGE_EDITOR,
            payload: { entryId: entry.id },
          }),
        )
      }
    },
    [dispatch, isListEmpty],
  )

  return (
    <KnowledgeEditor
      source={KnowledgeEditorSource.SIDEBAR}
      entryId={viewPayload?.entryId}
      newEntryType={viewPayload?.newEntryType}
      editMode={viewPayload?.editMode}
      onSave={handleSaved}
      onClose={handleClose}
    />
  )
}
